import constants from './constants';
import api from './api';
import {createAsyncAction} from '../../utils/thunk_utils';

export const createCalendar = (data) => (dispatch) => {
  dispatch(createAsyncAction(
      constants.CREATE_CALENDAR,
      api.createCalendar
  )(data));
};